import axios from 'axios'
import {BACKEND_API_URL, XC_API_URL} from '../../constants'

const XC_QUESTION_URL = `${XC_API_URL}/question/save-answer`;
const PHOTO_URL = `${BACKEND_API_URL}/questionnaire/photo`;
const QUESTIONS_URL = `${BACKEND_API_URL}/orm/scan/questions`;

const photoEndpoint = (id) => `${BACKEND_API_URL}/questionnaire/photo/${id}`;
const thumbnailEndpoint = (id) => `${photoEndpoint(id)}/thumbnail`;

function getQuestions(scanId) {
    return axios.get(QUESTIONS_URL, {
        params: {scanId: scanId}
    })
}

function saveNote(scanId, question, note) {
    axios.post(`${QUESTIONS_URL}/${question.code}/note`, note, {
        params: {scanId: scanId},
        headers: {'Content-Type': 'text/plain'}
    })
}

function saveQuestion(scanId, category, coverages, questionCode, questionText, answer) {
    const scanQuestion = {
        category: category,
        coverages: coverages,
        code: questionCode,
        question: questionText,
        answer: answer,
        riskClassification: "ORM"
    };
    return axios.put(XC_QUESTION_URL, scanQuestion, {
        params: {scanId: scanId}
    })
}

function uploadPhoto(scanId, questionId, mimeType, arrayBuf, progressCallback) {
    return axios.post(PHOTO_URL, arrayBuf, {
        params: {
            scanId: scanId,
            questionId: questionId
        },
        headers: {
            'Content-Type': mimeType
        },
        onUploadProgress: function (progressEvent) {
            let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            progressCallback(percentCompleted);
        }
    }).then(response => response.data)
}

export function deletePhoto(id) {
    return axios.delete(`${PHOTO_URL}/${id}`);
}

export {
    photoEndpoint,
    thumbnailEndpoint,
    getQuestions,
    saveNote,
    saveQuestion,
    uploadPhoto
}

